import isNaN from 'lodash/isNaN';
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import Input from '@Components/Input';

import './ChunkPickerGoToPage.custom.scss';

function ChunkPickerGoToPage(props) {
  const { chunksCount, onClick } = props;

  const [goToInputValue, setGoToInputValue] = React.useState(null);

  const onClickGoToButton = () => {
    const index = parseInt(goToInputValue, 10);
    onClick(index);
    setGoToInputValue('');
  };

  const onChangeGoToInput = (value) => {
    const valueAsInteger = parseInt(value, 10);
    const result = isNaN(valueAsInteger) ? '' : valueAsInteger;
    setGoToInputValue(result);
  };

  const validateGoToInputValue = (value) => {
    const valueAsInteger = parseInt(value, 10);

    if (value === '') {
      return true;
    }

    if (isNaN(valueAsInteger)) {
      return false;
    }

    if (valueAsInteger.toString().length !== value.toString().length) {
      return false;
    }

    if (valueAsInteger > chunksCount) {
      return false;
    }

    return valueAsInteger !== 0;
  };

  const onEnterGoToInput = (e) => {
    if (e.key !== 'Enter' || !goToInputValue) {
      return;
    }
    const index = parseInt(goToInputValue, 10);
    onClick(index);
    setGoToInputValue('');
  };

  if (chunksCount < 8) {
    return null;
  }
  return (
    <Input
      debounceDelay={50}
      clearButton={false}
      className="chunk-picker-go-to"
      classNameInput="chunk-picker-go-to_input"
      animatedPlaceholder
      placeholder="Go to page"
      value={goToInputValue}
      onChange={onChangeGoToInput}
      validateValueInput={validateGoToInputValue}
      afterLabelContent={
        <Button
          disabled={!goToInputValue}
          onClick={onClickGoToButton}
          buttonConfig={{
            type: 'link',
            size: 'sm',
            iconOnly: true,
            ariaLabel: 'Go to page',
            className: 'chunk-picker-go-to_button',
            e2eName: 'chunk-picker-go-to-button',
          }}
          iconConfig={{ name: 'chevron-right', size: 'sm' }}
        />
      }
      inputProps={{
        onKeyPress: onEnterGoToInput,
      }}
    />
  );
}

ChunkPickerGoToPage.propTypes = {
  chunksCount: PropTypes.number,
  onClick: PropTypes.func.isRequired,
};

export default ChunkPickerGoToPage;
